// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EZ0W","rootNoMargin":"styles_rootNoMargin__3IkIb"};